import React from "react";
import Link from "@mui/material/Link";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ArrowForwardOutlined from "@mui/icons-material/ArrowForwardOutlined";
import { Link as RouterLink } from "react-router-dom";
import Box from "@mui/material/Box";

/**
 * @param {object} props
 * @param {import("react-router-dom").To} props.link
 * @param {import("react").ReactNode} props.primary
 * @param {import("react").ReactNode} props.secondary
 * @param {() => React.JSX.Element} [props.Chip]
 */
export const MenuItem = ({ link, primary, secondary, Chip }) => {
  return (
    <ListItem>
      <ListItemText primary={primary} secondary={secondary} />
      {Chip && (
        <ListItemIcon>
          <Box justifyContent="center" alignItems="center" display="flex" flex={1}>
            <Chip />
          </Box>
        </ListItemIcon>
      )}
      <Link to={link} component={RouterLink}>
        <ListItemIcon>
          <ListItemButton>
            <ArrowForwardOutlined />
          </ListItemButton>
        </ListItemIcon>
      </Link>
    </ListItem>
  );
};
